<div class="attendee-box">
	<!--Search form-->
	<form *ngIf="isGridReady" class="searchGroup" (submit)="searchInput = searchTxt.value" [ngClass]="{active: searchInput}">
		<div class="input-group" role="group" [attr.aria-label]="'Event_AttendeesSearch' | translate">
			<input type="text" #searchTxt class="form-control searchInput" name="txtSearch" [placeholder]="'Event_AttendeesSearch' | translate" [attr.aria-label]="'Event_AttendeesSearchInput' | translate">
			<span class="input-group-btn">
				<button [attr.aria-label]="'Search' | translate" class="search-btn btn btn-transparent" type="submit"><span class="glyphicons search"></span></button>
			</span>
		</div>
	</form>

	<vb-ui-infinite-scroll-grid [columnDefs]="gridColumnDefs" [defaultColDef]="gridDefaultColumnDef" [gridOptions]="gridOptions" [context]="gridContext" [getRows]="AttendeeService.getRows" [clearScrollId]="AnalyticsService.clearEventScrollId" [quickFilterText]="searchInput" [pollingIntervalSecs]="listPollingIntervalInSec" [pageSize]="pageSize" (gridReady)="onGridReady()" [themed]="true" class="list-container">
	</vb-ui-infinite-scroll-grid>
</div>
